import gql from 'graphql-tag';
import { Map } from 'immutable';
import { normalize } from 'normalizr';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { ElementActions } from '../../actions/element';
import { RelationshipActions, relationshipSchema } from '../../actions/relationship';
// import Avatar from '../../components/Avatar';
// import MainContent from '../../components/MainContent';
import MainContent from './MainContent';
import ToastContainer from '../../components/ToastContainer';
import FullScreenModal from '../../components/modals/FullScreenModal';
import IconNavList from '../../components/toolbars/IconNavList';
import { getActionIds } from '../../helpers/redux';
import elementSchema from '../../schemas/element';
import '../../styles/Project.css';

const elementActions = getActionIds(ElementActions);
const relationshipActions = getActionIds(RelationshipActions);

// const PROJECT_USER_STATUS_QUERY = gql`
//   query projectUserStatus($projectId: ID!) {
//     projectUserStatus(projectId: $projectId) {
//       id
//       avatar {
//         id
//         path
//       }
//     }
//   }
// `;

// const PROJECT_USER_STATUS_CHANGED_SUBSCRIPTION = gql`
//   subscription onProjectUserStatusChanged($projectId: ID!) {
//     projectUserStatusChanged(projectId: $projectId) {
//       id
//       email
//       avatar {
//         id
//         path
//       }
//     }
//   }
// `;

// class ProjectAvatars extends React.Component {
//   userStatusLeftSubscription = null;
//   userStatusJoinedSubscription = null;

//   subscribe = () => {
//     this.userStatusLeftSubscription = this.props.subscribeToProjectUserStatusLeft();
//     this.userStatusJoinedSubscription = this.props.subscribeToProjectUserStatusJoined();
//   };

//   unsubscribe = () => {
//     this.userStatusLeftSubscription();
//     this.userStatusJoinedSubscription();
//   };

//   componentDidMount() {
//     this.subscribe();
//   }

//   componentWillUnmount() {
//     this.unsubscribe();
//   }

//   async componentWillReceiveProps(nextProps) {
//     const { projectId } = this.props;
//     if (nextProps.projectId !== projectId) {
//       console.log(
//         `projectId changed from ${projectId} to ${nextProps.projectId}`,
//       );
//       await this.unsubscribe();
//       this.subscribe();
//     }
//   }

//   render() {
//     // debugger;
//     const {
//       data: { projectUserStatus },
//     } = this.props;
//     if (!projectUserStatus) return <div>hi</div>;
//     // TODO: fix this Immutable nonsense
//     return (
//       <div>
//         {projectUserStatus.map(user => (
//           <Avatar
//             className="mr-1"
//             key={user.id}
//             avatar={Immutable.fromJS(user.avatar)}
//             user={Immutable.fromJS(user)}
//             width="37"
//             height="37"
//             rounded
//             enableToolTip
//           />
//         ))}
//       </div>
//     );
//   }
// }

// const NavBarWithProjectUserStatus = ({ projectId }) => {
//   return (
//     <Query
//       query={PROJECT_USER_STATUS_QUERY}
//       variables={{ projectId }}
//       fetchPolicy={'cache-and-network'}
//     >
//       {({ subscribeToMore, ...result }) => (
//         <ProjectAvatars
//           projectId={projectId}
//           {...result}
//           // subscribeToProjectUserStatusChanges={() =>
//           //   subscribeToMore({
//           //     document: PROJECT_USER_STATUS_CHANGED_SUBSCRIPTION,
//           //     variables: { projectId },
//           //     updateQuery: (prev, { subscriptionData }) => {
//           //       debugger;
//           //       if (!subscriptionData.data) return prev;
//           //       const newFeedItem = subscriptionData.data.commentAdded;

//           //       return Object.assign({}, prev, {
//           //         entry: {
//           //           comments: [newFeedItem, ...prev.entry.comments],
//           //         },
//           //       });
//           //     },
//           //   })
//           // }
//           subscribeToProjectUserStatusLeft={() =>
//             subscribeToMore({
//               document: gql`
//                 subscription onProjectUserStatusLeft($projectId: ID!) {
//                   projectUserStatusLeft(projectId: $projectId) {
//                     id
//                     avatar {
//                       id
//                       path
//                     }
//                   }
//                 }
//               `,
//               variables: { projectId },
//               updateQuery: (prev, { subscriptionData }) => {
//                 if (!subscriptionData.data) return prev;

//                 return {
//                   ...prev,
//                   projectUserStatus: prev.projectUserStatus.filter(
//                     u =>
//                       u.id !== subscriptionData.data.projectUserStatusLeft.id,
//                   ),
//                 };
//               },
//             })
//           }
//           subscribeToProjectUserStatusJoined={() =>
//             subscribeToMore({
//               document: gql`
//                 subscription onProjectUserStatusJoined($projectId: ID!) {
//                   projectUserStatusJoined(projectId: $projectId) {
//                     id
//                     avatar {
//                       id
//                       path
//                     }
//                   }
//                 }
//               `,
//               variables: { projectId },
//               updateQuery: (prev, { subscriptionData }) => {
//                 if (!subscriptionData.data) return prev;
//                 const projectUserStatus = prev.projectUserStatus || [];
//                 // console.log('poo', prev, prev.projectUserStatus);
//                 // debugger;
//                 return {
//                   ...prev,
//                   projectUserStatus: [
//                     ...projectUserStatus.filter(
//                       u =>
//                         u.id !==
//                         subscriptionData.data.projectUserStatusJoined.id,
//                     ),
//                     subscriptionData.data.projectUserStatusJoined,
//                   ],
//                 };
//               },
//             })
//           }
//         />
//       )}
//     </Query>
//   );
// };

const elementTypeBaseFragment = gql`
  fragment ElementType on ElementType {
    created_at
    created_by_id
    deleted_at
    description
    icon_id
    id
    project_id
    props
    restored_at
    updated_at
  }
`;

const elementBaseFragment = gql`
  fragment Element on Element {
    created_at
    custom_props
    datasource_id
    deleted_at
    external_id
    icon_id
    id
    id_path
    name
    order
    parent_id
    project_id
    props
    restored_at
    search_path
    # tags {
    #   id
    # }
    type {
      ...ElementType
    }
    type_id
    updated_at
  }
  ${elementTypeBaseFragment}
`;

const PROJECT_ELEMENT_CHANGED_SUBSCRIPTION = gql`
  subscription onProjectElementChanged($projectId: ID!) {
    projectElementChanged(projectId: $projectId) {
      ...Element
      children {
        ...Element
      }
      consumesFrom {
        ...Element
      }
      parent {
        ...Element
      }
      providesTo {
        ...Element
      }
    }
  }
  ${elementBaseFragment}
`;

const PROJECT_ELEMENT_CREATED_SUBSCRIPTION = gql`
  subscription onProjectElementCreated($projectId: ID!) {
    projectElementCreated(projectId: $projectId) {
      ...Element
      children {
        ...Element
      }
      consumesFrom {
        ...Element
      }
      parent {
        ...Element
      }
      providesTo {
        ...Element
      }
    }
  }
  ${elementBaseFragment}
`;

const PROJECT_ELEMENT_DELETED_SUBSCRIPTION = gql`
  subscription onProjectElementDeleted($projectId: ID!) {
    projectElementDeleted(projectId: $projectId) {
      ...Element
      children {
        ...Element
      }
      consumesFrom {
        ...Element
      }
      parent {
        ...Element
      }
      providesTo {
        ...Element
      }
    }
  }
  ${elementBaseFragment}
`;

const ELEMENT_RELATIONSHIPS_CHANGED_SUBSCRIPTION = gql`
  subscription onProjectElementRelationshipsChanged($projectId: ID!) {
    projectElementRelationshipsChanged(projectId: $projectId) {
      consumer
      created_at
      custom_props
      datasource_id
      deleted_at
      icon_id
      id
      producer
      project_id
      props
      restored_at
      strength
      type_id
      updated_at
    }
  }
`;

const ELEMENT_RELATIONSHIPS_DELETED_SUBSCRIPTION = gql`
  subscription onProjectElementRelationshipsDeleted($projectId: ID!) {
    projectElementRelationshipsDeleted(projectId: $projectId) {
      consumer
      created_at
      custom_props
      datasource_id
      deleted_at
      icon_id
      id
      producer
      project_id
      props
      restored_at
      strength
      type_id
      updated_at
    }
  }
`;

// const SubscriptionTest = connect()(({ dispatch, projectId }) => (
//   <Subscription
//     subscription={PROJECT_ELEMENT_CHANGED_SUBSCRIPTION}
//     variables={{ projectId: 1567 }}
//   >
//     {/* {({ data: { elementChanged } }) => { */}
//     {x => {
//       // "children", "parent", "childrenOfChildren", "consumesFrom", "providesTo"
//       console.log('dispatch', dispatch);
//       console.log('MOO', x);
//       if (!x.data || !x.data.projectElementChanged) return <div>loading</div>;
//       const response = x.data.projectElementChanged;
//       const y = normalize(response, elementSchema);
//       // debugger;
//       dispatch({
//         type: elementActions.getElement.success,
//         result: y,
//       });
//       return <div>hi {JSON.stringify(x)}</div>;
//     }}
//   </Subscription>
// ));

// const withSubscriptions = compose(
//   graphql(PROJECT_ELEMENT_CHANGED_SUBSCRIPTION, {
//     options: ({ params }) => ({
//       variables: {
//         projectId: 1567, // params.organizationId,
//       },
//     }),
//   }),
//   graphql(PROJECT_ELEMENT_CHANGED_SUBSCRIPTION, {
//     options: ({ params }) => ({
//       variables: {
//         projectId: 1567, // params.organizationId,
//       },
//     }),
//   }),
// );

// @withSubscriptions
@connect()
@withApollo
class Project extends Component {
  static propTypes = {
    project: PropTypes.instanceOf(Map),
    routeParams: PropTypes.object,
    userMode: PropTypes.string,
    children: PropTypes.object,
    location: PropTypes.object,
  };

  elementChangedSubscription = null;
  elementCreatedSubscription = null;
  elementDeletedSubscription = null;
  elementRelationshipsChangedSubscription = null;
  elementRelationshipsDeletedSubscription = null;

  componentDidMount() {
    const { dispatch, project } = this.props;

    this.elementChangedSubscription = this.props.client
      .subscribe({
        query: PROJECT_ELEMENT_CHANGED_SUBSCRIPTION,
        variables: {
          projectId: project.get('id'),
        },
      })
      .subscribe({
        next: ({ data: { projectElementChanged } }) => {
          console.log('projectElementChanged', projectElementChanged);
          const result = normalize(projectElementChanged, elementSchema);
          dispatch({
            args: [null, projectElementChanged],
            type: elementActions.getElement.success,
            result,
          });
        },
        error: err => {
          console.log('err', err);
        },
      });

    this.elementCreatedSubscription = this.props.client
      .subscribe({
        query: PROJECT_ELEMENT_CREATED_SUBSCRIPTION,
        variables: {
          projectId: project.get('id'),
        },
      })
      .subscribe({
        next: ({ data: { projectElementCreated } }) => {
          console.log('projectElementCreated', projectElementCreated);
          const result = normalize(projectElementCreated, elementSchema);
          dispatch({
            args: [null, projectElementCreated],
            type: elementActions.getElement.success,
            result,
          });
        },
        error: err => {
          console.log('err', err);
        },
      });

    this.elementDeletedSubscription = this.props.client
      .subscribe({
        query: PROJECT_ELEMENT_DELETED_SUBSCRIPTION,
        variables: {
          projectId: project.get('id'),
        },
      })
      .subscribe({
        next: ({ data: { projectElementDeleted } }) => {
          console.log('projectElementDeleted', projectElementDeleted);
          dispatch({
            type: elementActions.deleteElement.success,
            args: [
              { id: projectElementDeleted.id, projectId: project.get('id') },
              true,
            ],
            result: {
              id: projectElementDeleted.id,
              success: true,
            },
          });
        },
        error: err => {
          console.log('err', err);
        },
      });

    this.elementRelationshipsChangedSubscription = this.props.client
      .subscribe({
        query: ELEMENT_RELATIONSHIPS_CHANGED_SUBSCRIPTION,
        variables: {
          projectId: project.get('id'),
        },
      })
      .subscribe({
        next: ({ data: { projectElementRelationshipsChanged } }) => {
          console.log(
            'projectElementRelationshipsChanged',
            projectElementRelationshipsChanged,
          );
          const result = normalize(projectElementRelationshipsChanged, [
            relationshipSchema,
          ]);

          dispatch({
            type: relationshipActions.patchRelationships.success,
            result,
          });
        },
        error: err => {
          console.log('err', err);
        },
      });

    this.elementRelationshipsDeletedSubscription = this.props.client
      .subscribe({
        query: ELEMENT_RELATIONSHIPS_DELETED_SUBSCRIPTION,
        variables: {
          projectId: project.get('id'),
        },
      })
      .subscribe({
        next: ({ data: { projectElementRelationshipsDeleted } }) => {
          console.log(
            'projectElementRelationshipsDeleted',
            projectElementRelationshipsDeleted,
          );

          dispatch({
            type: relationshipActions.deleteRelationships.success,
            result: {
              relationships: projectElementRelationshipsDeleted,
              relationshipIdsToDelete: projectElementRelationshipsDeleted.map(rel => rel.id),
            }
          });
        },
        error: err => {
          console.log('err', err);
        },
      });
  }

  // componentWillReceiveProps() {
  //   debugger;
  // }

  componentWillUnmount() {
    // unsubscribe
    this.elementChangedSubscription.unsubscribe();
    this.elementCreatedSubscription.unsubscribe();
    this.elementDeletedSubscription.unsubscribe();
    this.elementRelationshipsChangedSubscription.unsubscribe();
    this.elementRelationshipsDeletedSubscription.unsubscribe();
  }

  render() {
    const { project, routeParams, userMode, children, location } = this.props;
    // console.log('pid', project.get('id'));
    return (
      <div className="project-viewer project-flex">
        <ToastContainer />
        {/* <NavBar routeParams={routeParams} /> */}
        {/* <NavBarWithProjectUserStatus projectId={project.get('id')} /> */}
        <div className="row" style={{ flex: 1 }}>
          <div className="project-container">
            <div className="project-left-column">
              <IconNavList
                project={project}
                projectId={project.get('id')}
                industryId={project.get('industry_id')}
                userMode={userMode}
                location={location}
              />
            </div>
            <div className="project-right-column">
              <MainContent
                project={project}
                children={children}
                routeParams={routeParams}
              />
            </div>
          </div>
          <FullScreenModal />
        </div>
      </div>
    );
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/views/Project/Project.js